<app-typeFNS-simple-desc-marche2 [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[natureMarche]="fnSimpleAnnulation.natureMarche"></app-typeFNS-simple-desc-marche2>
